import React from 'react';
import { FaFileDownload, FaEnvelope } from 'react-icons/fa';
import { Link } from 'react-scroll';

const Home = () => {
  return (
    <section
      name='home'
      className='relative w-full min-h-screen flex items-center bg-bg overflow-hidden'
    >
      {/* Subtle accent glow */}
      <div className='absolute -top-32 -left-32 w-[40rem] h-[40rem] rounded-full bg-accent/10 blur-[120px] pointer-events-none' />
      <div className='absolute bottom-0 right-0 w-[28rem] h-[28rem] rounded-full bg-emerald-500/5 blur-[100px] pointer-events-none' />

      <div className='container-narrow relative z-10'>
        {/* Status badge */}
        <div className='inline-flex items-center gap-2 px-3 py-1 mb-6 rounded-full border border-accent/30 bg-accent/5 animate-fade-up'>
          <span className='relative flex h-2 w-2'>
            <span className='animate-ping absolute inline-flex h-full w-full rounded-full bg-accent opacity-60' />
            <span className='relative inline-flex rounded-full h-2 w-2 bg-accent' />
          </span>
          <span className='font-mono text-xs text-accent tracking-wider uppercase'>
            Open to opportunities
          </span>
        </div>

        <p className='font-mono text-accent text-sm sm:text-base mb-4 animate-fade-up'>
          Hi, my name is
        </p>

        <h1 className='text-5xl sm:text-7xl font-bold text-white tracking-tight animate-fade-up'>
          Thanushan <span className='text-zinc-400'>"Shan"</span>
        </h1>
        <h1 className='text-5xl sm:text-7xl font-bold text-white tracking-tight mb-6 animate-fade-up'>
          Varatharajah<span className='text-accent'>.</span>
        </h1>

        <h2 className='text-2xl sm:text-4xl font-semibold text-zinc-400 max-w-3xl mb-6 animate-fade-up'>
          Senior Software Engineer.
        </h2>

        <p className='text-zinc-400 text-base sm:text-lg leading-relaxed max-w-2xl mb-10 animate-fade-up'>
          Nearly a decade across <span className='text-accent font-medium'>Java</span>,{' '}
          <span className='text-accent font-medium'>Spring Boot</span>, and{' '}
          <span className='text-accent font-medium'>Quarkus</span> backends — and the test automation
          that proves they work. I sit comfortably between writing production services and designing
          the Karate, Playwright, and k6 suites that catch their edge cases. CI/CD on Jenkins,
          GitHub Actions, and Concourse. AWS Certified Solutions Architect.
        </p>

        <div className='flex flex-wrap gap-4 animate-fade-up'>
          <a
            href='/Thanushan_Varatharajah_Resume.pdf'
            target='_blank'
            rel='noopener noreferrer'
            className='btn-primary'
          >
            <FaFileDownload /> Download Resume
          </a>
          <Link to='contact' smooth={true} duration={500} className='btn-outline cursor-pointer'>
            <FaEnvelope /> Get in touch
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Home;
